import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DescriptionList, {
  DescriptionListItem,
} from '../../../../components/description_list/DescriptionList';
import { useGetBreedInfo } from '../../../../utils/breedHelpers';
import { getMedia } from '../../../../utils/mediaHelpers';
import { BreedNodeProps } from '../types';

const BreedTitleSection: React.FC<{ node: BreedNodeProps }> = ({ node }) => {
  const breedInfoList = useGetBreedInfo(node?.field_breed_info ?? {});
  const filteredBreedInfoList = (breedInfoList?.filter(item => item !== null) ??
    []) as DescriptionListItem[];

  return (
    <div className="pds-bg-surface-layer pds-px-4 pds-py-5 md:pds-py-6">
      <Container>
        <div className="pds-mx-auto pds-max-w-site-container">
          <Row className="pds-items-center pds-justify-center">
            <Row className="md:pds-text-center">
              <Col lg={12}>
                <h1 className="pds-mb-5 pds-hyphens-auto pds-break-words pds-text-display-sm pds-capitalize md:pds-mb-6">
                  {node.title}
                </h1>
              </Col>
            </Row>
            <div className="pds-my-3 pds-flex pds-flex-col pds-items-start pds-justify-center pds-gap-4.5 md:pds-flex-row md:pds-gap-5 lg:pds-my-4">
              <div className="pds-max-w-full pds-flex-[1_0_auto] pds-rounded-xl pds-bg-white pds-text-center md:pds-max-w-[50%]">
                {getMedia({
                  media: node.relationships.field_image,
                  loading: 'eager',
                })}
              </div>
              {filteredBreedInfoList && (
                <div className="pds-w-full pds-p-0">
                  <DescriptionList items={filteredBreedInfoList} />
                </div>
              )}
            </div>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default BreedTitleSection;
